import LogoImage from "../assets/dashboard/Avana-logo.svg";

const ImageLoader = () => {
  return (
    <div className="h-screen max-h-[90dvh] w-full flex items-center justify-center bg-white">
      <img
        src={LogoImage}
        alt="Avaana Logo"
        className="h-40 w-auto animate-pulse"
      />
    </div>
  );
};

export default ImageLoader;
